module.exports = __webpack_public_path__ + "img/img_61290_0_6.aa209326.png";